"use client";

import Link from "next/link";
import { StrapiImage } from "@/comp/_Utility/StrapiImage";
import { Navigatsioon, navItem } from "@/types/strapi-global";

const styleMap: Record<string, string> = {
    normal: "font-medium",
    special: "px-4 py-2 rounded-md border-2 border-blue-400 hover:border-pink-400 transition-all duration-500 font-medium"
};

/**
 * Resolves the destination URL for a navigation item.
 */
function getItemUrl(item: navItem): string {
    if (item.isExternalUrl) {
        return item.ItemExternalUrl || "#";
    }

    if (item.itemPageLink?.pageUrl) {
        return `/${item.itemPageLink.pageUrl}`;
    }

    return "#";
}

export default function DesktopNav({ data }: { data: Navigatsioon }) {
    const categories = data?.navCategory || [];
    console.log(categories)

    return (
        <div className="hidden lg:flex fixed top-0 w-full h-[10vh] items-center justify-around bg-white shadow-sm px-6">
            {/* Logo */}
            <Link href="/" className="h-[70%]">
                {data?.logo && (
                    <StrapiImage media={data.logo} className="h-full w-auto object-contain" />
                )}
            </Link>

            {/* Navigation Categories */}
            <ul className="flex items-center gap-4">
                {categories.map((cat, idx) => {
                    const navItems = cat?.navItem || [];

                    return (
                        <li
                            key={idx}
                            className="relative group py-4 mx-2 hover:text-pg-blue transition-all duration-300 rounded-b-lg p-2"
                        >
                            {/* Category Title Header */}
                            <div className="cursor-pointer flex items-center gap-1">
                                <span className={styleMap[cat.categoryStyle] || styleMap.normal}>
                                    {cat.categoryTitle}
                                </span>
                                {navItems.length > 0 && (
                                    <span className="text-[10px] opacity-50 group-hover:rotate-180 transition-transform">
                                        ▼
                                    </span>
                                )}
                            </div>

                            {/* Dropdown Menu */}
                            {navItems.length > 0 && (
                                <ul className="absolute left-0 top-full w-52 bg-white text-sm hover:text-pg-purple font-light shadow-xl rounded-b-lg opacity-0 pointer-events-none group-hover:opacity-100 group-hover:pointer-events-auto transition-all">
                                    {navItems.map((item, i) => {
                                        const href = getItemUrl(item);

                                        return (
                                            <li key={i} className="hover:bg-gray-100 rounded-b-lg text-wrap">
                                                <Link
                                                    href={href}
                                                    target={item.openInNewTab ? "_blank" : undefined}
                                                    rel={item.openInNewTab ? "noopener noreferrer" : undefined}
                                                    className="transition-all duration-300 block px-4 py-3 text-gray-700 hover:text-black"
                                                >
                                                    {item.itemTitle}
                                                </Link>
                                            </li>
                                        );
                                    })}
                                </ul>
                            )}
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}